import { useEffect, useState } from 'react';
import useSWR from 'swr';

import { clientApiGet } from 'lib/api_helper';
import { Offer, PurchaseRequest } from 'types';

const titleMap: Record<Offer['cancellationReason'], string> = {
  SELLER_DECLINED: 'SELLER DECLINED YOUR OFFER',
  EXPIRED: 'YOUR OFFER EXPIRED'
};

export const useCreateRequestBottomSheet = (offer: Offer, isSeller: boolean, isOpen: boolean) => {
  const [isRequestSheetCanBeShown, setIsRequestSheetCanBeShown] = useState(true);
  const [isRequestSheetVisible, setIsRequestSheetVisible] = useState(false);

  const shouldShow = offer.cancellationReason === 'SELLER_DECLINED' || offer.cancellationReason === 'EXPIRED';

  const { data: requests } = useSWR<PurchaseRequest[]>(
    shouldShow && isOpen && !isSeller
      ? `/api/purchaseRequests/getRequests?buyerProfile[]=${offer.buyerProfile.id}&model[]=${offer.listing.model.id}&status[]=LIVE`
      : null,
    clientApiGet
  );

  useEffect(() => {
    if (isSeller || !shouldShow || requests === undefined || requests.length > 0 || !isRequestSheetCanBeShown) {
      return;
    }

    setIsRequestSheetCanBeShown(false);
    setIsRequestSheetVisible(true);
  }, [isRequestSheetCanBeShown, shouldShow, requests, isSeller]);

  return { isRequestSheetVisible, setIsRequestSheetVisible, titleText: titleMap[offer.cancellationReason] };
};
